export default __webpack_public_path__ + "static/media/logo2.3d7f666f.png";